<template>
  <el-card class="h-full relative">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="考试名称"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.examCategory"
          size="small"
          class="mr-10px !w-50 mb-10px mb-10px"
          placeholder="请选择考试类型"
          clearable
        >
          <el-option
            v-for="item in pagerTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="searchData.startTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('开始日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          v-model="searchData.endTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          v-model="searchData.readStatusEnum"
          size="small"
          :placeholder="`${$t('状态')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in trainingType"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="考试名称" prop="examName" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row | showText('name') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试编码" prop="examCode" show-overflow-tooltip width="180" />
        <el-table-column label="所属场次" prop="sessionName" show-overflow-tooltip width="120" />
        <el-table-column
          label="考试类型"
          prop="examCategoryText"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column label="考试时间" prop="examStartTime" show-overflow-tooltip width="300">
          <template slot-scope="scope">
            <span>{{ scope.row | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="考试总时长"
          prop="totalPlanExamDuration"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          label="参加总人数"
          prop="personTotalCount"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column label="状态" prop="readStatusText" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewInfo(scope.row, 1)" v-if="scope.row.personTotalCount"
              >阅卷</el-button
            >
            <!-- <el-button size="mini" @click="viewInfo(scope.row, 2)">查看</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="searchList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { ReadExamPaperApi } from '@wiz-api/exam-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import { formatSeconds } from '../../components/EnumField'

const readExamPaperApi = new ReadExamPaperApi()

export default {
  name: 'examine-paper',
  data() {
    return {
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      searchData: {
        keywords: '',
        startTime: '',
        endTime: '',
        readStatusEnum: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      trainingType: ['待阅卷', '阅卷中', '已完成'],
      pagerTypeList: [],
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - ${dayjs(
          val.examEndTime
        ).format('YYYY-MM-DD HH:mm')}`
      }
      if (type === 'name') {
        result = `${val.examName}--${val.sessionName}`
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    // 查看学习情况
    async viewInfo(data, type) {
      const [err] = await readExamPaperApi.setReadPapaer(data.id)
      if (!err) {
        const url = Wiz?.globalSettings?.globalConfig?.routerBase
          ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage/examine-paper`
          : '/educational-training-management-sm/exam-manage/examine-paper'
        this.$router.push({
          path: url,
          query: { id: data.id, sceneId: data.examPlanId, type, name: data.examName },
        })
      } else {
        this.searchList()
      }
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 列表
    async searchList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        ...searchData,
      }
      // if (data.startTime) {
      //   data.startTime = dayjs(data.startTime).format('YYYY-MM-DD HH:mm:ss')
      // }
      // if (data.endTime) {
      //   data.endTime = dayjs(data.endTime).format('YYYY-MM-DD 23:59:59')
      // }
      this.equipTableLoading = true
      const [err, res] = await readExamPaperApi.pagedListQuery(data)
      this.equipTableLoading = false
      if (!err) {
        this.equipDataList = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  mounted() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
